$(function () {
  $('#p-floating-btn').on('click', function () {
    $('#p-floating').fadeOut();
  });
});